import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface ShowLayoutButtonTooltipCommand {
  position: {
    inverseY: number;
    x: number;
    y: number;
  };
  unsaved: boolean;
}

export const showLayoutButtonTooltip: GraphCommandFactory<
  ShowLayoutButtonTooltipCommand
> = (cmdContext) => (command) => {
  cmdContext.updateState((draft) => {
    draft.tooltip = {
      moveWithMouse: false,
      position: command.position,
      payload: {
        type: 'layoutButton',
        unsaved: command.unsaved,
      },
    };
  });
};
